import { AfterViewInit, Component, DestroyRef, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { loadManageCampaignList, putCampaignByPropertiesSuccess } from 'app/campaign/features/campaign.actions';
import { selectTicketingCampaignList } from 'app/campaign/features/campaign.selectors';
import { CampaignService } from 'app/campaign/services';
import { RaffleDrawComponent } from 'app/core/components/modals/raffle-draw/raffle-draw.component';
import { ModalUpdateSeatsService } from 'app/ticketing-and-guests/services/modal-update-seats/modal-update-seats.service';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { TicketsAndGuestsStateService } from 'app/manage-tickets-and-guests/services/tickets-and-guests-tabs.service';
import { EventService } from 'app/event/services/event.service';
import { RouteReuseStrategyService } from 'app/router-wrapper/services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-tickets-and-guests-details',
  standalone: true,
  imports: [CommonModule,CoreModule],
  templateUrl: './tickets-and-guests-details.component.html',
  styleUrl: './tickets-and-guests-details.component.scss'
})
export class TicketsAndGuestsDetailsComponent implements OnInit,OnDestroy, AfterViewInit{
  private destroyRef = inject(DestroyRef)
  public selectedTab = '';
  public selectedTicketingCampaignId: string;

  selectedTicketingCampaign: any;
  updatedOnProperty: Date | null = null;

  public typeData: any | null;
  public linkedEvent : any | null
  public eventType :"In-Person" | "Virtual" | null = null;
  public showConnectToEventButton: boolean = false;

  private ticketingCampaignsSelector$ = this.store.pipe(
    select(selectTicketingCampaignList),
    takeUntilDestroyed()
  );
  

  public takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();
  
  constructor(
    public router:Router,
    private route: ActivatedRoute,
    private store: Store,
    private element: ElementRef,
    private campaignService: CampaignService,
    private modalService: MdbModalService,
    private modalUpdateSeatsService: ModalUpdateSeatsService,
    private sharedService: SharedService,
    private stateService: TicketsAndGuestsStateService,
    private eventService: EventService,
    private routeReuseStrategyService: RouteReuseStrategyService,
  )
  {}

  ngOnInit(): void {
    const $ = window['$'];

    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(({ future }) => {
      switch(future.fragment) {
        case "":
          $(`#ticketsTabNav`).tab('show');
          break;
        default:
          $(`#${future.fragment}Nav`).tab('show');
      }
    });

    this.store.dispatch({
      type: loadManageCampaignList.type,
      payload: this.sharedService.token,
      campaignTypes:[6],
    });
    
    this.route.paramMap.subscribe(params => {
      this.selectedTicketingCampaignId = params.get('id');
    });

    this.ticketingCampaignsSelector$.subscribe(list => {
      this.selectedTicketingCampaign = list?.find(item => item.id === this.selectedTicketingCampaignId)
      this._updateCampaignData()
    })
  }

  private _updateCampaignData() {
    if(!this.selectedTicketingCampaign?.campaignTypeData){
      return;
    }

    this.typeData = this.selectedTicketingCampaign.campaignTypeData;

    this.setLinkedEvent();

    this.showConnectToEventButton = 
      !this.typeData.linkedEventId &&
      !this.typeData.linkedVirtualEventID &&
      !this.typeData.isRaffleTicket;

    this.updatedOnProperty = new Date(this.selectedTicketingCampaign.updated * 1000);
  }

  private setLinkedEvent() {
    if (this.typeData.linkedEventId) {
      this.linkedEvent = this.typeData.linkedEvent;
      this.eventType = "In-Person";
    }
    else if (this.typeData.linkedVirtualEventID) {
      this.linkedEvent = this.typeData.linkedVirtualEvent;
      this.eventType = "Virtual";
    }
  }

  ngOnDestroy(): void {
    window['$']("#ticketingReport").hide();
    window['$']("#ticketingReport").empty();

    window['$'](this.element.nativeElement).off("click");
  }

  modalRef: any;
  
  openUpdateSeatsModal(table) {
    const modalRef = this.modalUpdateSeatsService.open(table);
    
    modalRef.onClose.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() =>{})
  }
  
  onDrawModalClick(){
    let campaign = window['ticketingAndGuestsModal'].campaign
    this.campaignService.raffleDraw(campaign.id)
    .pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((data:any)=>{
      let isArray = false
      if(Array.isArray(data)){
        isArray = true
      }
      this.modalRef = this.modalService.open(RaffleDrawComponent, {
        ignoreBackdropClick: false,
        modalClass:`modal--paybee ${ isArray ? 'modal-lg' : ''}`,
        containerClass:'mdb-modal-backdrop-paybee',
        data: {
          isArray,
          data,
          campaign: this.selectedTicketingCampaign,
          onClose: ()=>{
            this.modalRef.close()
          }
        }
      });
    })
  }

  onRedirectToList(){
    this.router.navigateByUrl('/manage/tickets-and-guests/list');

  }
  
    // onCustomRemainderClick(){
    //   const action = DialogActions.openDialog({
    //     payload: {
    //       name: "customReminder",
    //       options: {
    //         size: 'lg',
    //         modalClass:'modal--paybee modal-lg',
    //         containerClass:'mdb-modal-backdrop-paybee'
    //       },
    //       initialState: {}
    //     }
    //   });
    //   this.store.dispatch(action);
    // }
  
  ngAfterViewInit(): void {
    const self = this;
    const $ = window['$'];
    const [, fragment] = this.router.url.split("#");

    let selectedTab = null;
    switch(fragment) {
      case "ticketsTab":
      case "guestsTab":
      case "guestTableTab":
      case "golfHoleTab":
      case "invitesTab":
      case "remindersTab":
      case "promoCodesTab":
        selectedTab = fragment.slice(0, -3);
        break;
      default:
        selectedTab = 'tickets';
    }

    if(fragment) {
      $(`#${fragment}Nav`).tab('show');
    }

    const initCampaignData = () => {
      this._updateCampaignData()
      window['ticketingAndGuestsModal'].updateAngularCampaignDataCallback = (updatedCampaign) => {
        this.selectedTicketingCampaign = updatedCampaign;
        this._updateCampaignData();
      }
      window['ticketingAndGuestsModal'].updateCampaignSuccessActionCallback = (updatedCampaign) => {
        this.store.dispatch({
          type: putCampaignByPropertiesSuccess.type,
          updatedCampaign:updatedCampaign
        })
      }
      window['orgMain'].showTicketingReport(this.selectedTicketingCampaign, selectedTab);
      self.stateService.selectedCampaignId = self.selectedTicketingCampaignId
  
      $(this.element.nativeElement).off("click");

      $(this.element.nativeElement).on("click", "a[role='tab']", function(event) {
        event.preventDefault();
  
        const fragment = $(this).data('fragment');
        self.router.navigate([], { relativeTo: self.route, fragment });
      });

      $(this.element.nativeElement).on("click", "a[id^='ticketGuestList_']", function(event: PointerEvent) {
        event.preventDefault();

        const [, id] = this.id.split("_");
        self.router.navigate([`manage/tickets-and-guests/ticket/${id}/guest/list`], { fragment: 'ticketConfirmedGuestsTab' });
        $(`#${this.id}`).tooltip('hide');
      });

      $(this.element.nativeElement).on("click", "a[id^='ticketBasketRaffle_']", function(event: PointerEvent) {
        event.preventDefault();

        const [, id] = this.id.split("_");
        self.router.navigateByUrl(`manage/tickets-and-guests/ticket/${id}/basket-raffle/allocation/list`);
        $(`#${this.id}`).tooltip('hide');
      });

      $(this.element.nativeElement).on("click", "a[id^='manageSeats_']", function(event: PointerEvent) {
        event.preventDefault();

        const [, tableId] = this.id.split("_");
        self.router.navigateByUrl(`manage/tickets-and-guests/campaign/${self.selectedTicketingCampaignId}/table/${tableId}/seat/list`);
        $(`#${this.id}`).tooltip('hide');
      });
  
    }

    if(!this.stateService.selectedCampaign){
      this.ticketingCampaignsSelector$.subscribe(list => {
        if(!list){
          return;
        }
        
        if(list.length === 0){
          this.store.dispatch({
            type: loadManageCampaignList.type,
            payload: this.sharedService.token,
            campaignTypes:[6],
          });
  
          return;
        }
  
        this.selectedTicketingCampaign = list?.find(item => item.id === this.selectedTicketingCampaignId)
        initCampaignData()
      })
    } else{
      this.selectedTicketingCampaign = this.stateService.selectedCampaign;
      initCampaignData();
    }
  }
  
  onClickImport() {
    const eventId = window['ticketingAndGuestsModal'].event.id

    const action = DialogActions.openDialog({
      payload: {
        name: "importTables",
        options: {
          size: 'large',
          modalClass:'modal--paybee modal-lg',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          eventId: eventId
        }
      }
    });
    this.store.dispatch(action);
  }
  
  onClickViewAndDownloadPaddle(clickEvent, scrollToId = '') {
    clickEvent.preventDefault();

    const redirectToManagePaddles = () => {

      window['$']("#assignPaddlesToAll").modal("hide");
      const eventId = event.id;
      this.router.navigateByUrl(`event/in-person/${eventId}/report`);

      const subscription = this.router.events.pipe(
        filter(e => Object.prototype.hasOwnProperty.call(e, "routerEvent")),
        filter((e: any) => e.routerEvent instanceof NavigationEnd),
      ).subscribe(() => {
        window['$']('a[href="#panelIPaddles"]').click();

        if (scrollToId) {
          let attempts = 0;
          const maxAttempts = 50; // 5 seconds total (50 * 100ms)
          
          const checkAndScroll = () => {
            const $ = window['$'];
            const element = document.getElementById(scrollToId);
            const tabContent = $('#panelIPaddles');
            
            if (element && tabContent.is(':visible')) {
              element.scrollIntoView({ behavior: 'smooth', block: 'end' });
            } else if (attempts < maxAttempts) {
              attempts++;
              setTimeout(checkAndScroll, 100);
            }
          };
  
          setTimeout(checkAndScroll, 300);
        }

        subscription.unsubscribe();
      });
    }

    const event = window['ticketingAndGuestsModal'].event;
    if(!event.paddleRequired){
      const message = '[Guest will be assigned paddle numbers] setting is currently DISABLED. You can ENABLE it here or on Manage -> Events -> Edit'
      const paddleTempalate$ = window['orgMain'].getPaddlesNotificationModal(
          message,
          'assignPaddlesToAll',
          redirectToManagePaddles,
      )
      
      $('#assignPaddlesToAll_disabledSection').empty();
      $('#assignPaddlesToAll_disabledSection').html(paddleTempalate$);
      $('#assignPaddlesToAll_disabledSection').show();
      $('#assignPaddlesToAll_activeSection').hide();
      window['$']("#assignPaddlesToAll").modal("show");
      return;
    }

    redirectToManagePaddles();
  }

  onConnectToEventClick(){
    const reloadCallback = () => {
      // const name = 'ticketing';
      // this.store.dispatch({
      //   type: loadCampaign.type,
      //   payload: { name, payload: this.selectedTicketingCampaign }
      // });
      window['ticketingAndGuestsModal'].getCampaign(this.selectedTicketingCampaign.id).then((campaign) => {
        this.selectedTicketingCampaign = campaign;
        this.selectedTicketingCampaign.campaignTypeData.linkedEvent = window['ticketingAndGuestsModal'].event;
        this.selectedTicketingCampaign.campaignTypeData.linkedVirtualEvent = window['ticketingAndGuestsModal'].vEvent;
        this._updateCampaignData()
       })
    };

    window['ticketingAndGuestsModal']
    .connectCampaignToEvent(this.typeData, this.selectedTicketingCampaign,reloadCallback)
  }

  onEnableTableAssignment(){
    const payload = {
      ...this.linkedEvent,
      tableRequired: true,
    }

    this.eventService.updateEvent(payload)
    .pipe(
      takeUntilDestroyed(this.destroyRef),
    )
    .subscribe({
      next: updatedEvent => {
        this.linkedEvent = updatedEvent;
        window['ticketingAndGuestsModal'].campaign = this.selectedTicketingCampaign;
        window['ticketingAndGuestsModal'].event = updatedEvent;
        window['ticketingAndGuestsModal'].showTablesPage();
      }
    })
  }
}
